import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Fab } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { DashboardContext } from '../../context'
import { URLAPP, URLQUERY } from '../../config'
import DocumentationProvider from '../../context/DocumentationContext'
import DocDisplayFullScreen from './DocDisplayFullScreen'

interface SectionHelperProps {
    children: React.ReactNode
}

export default function SectionHelper({ children }: SectionHelperProps) {
    const location = useLocation();
    const navigate = useNavigate();
    const dashboardContext = useContext(DashboardContext)
    const [helpDocument, setHelpDocument] = useState('');

    useEffect(() => {
        let currentPath = location.pathname
        let matches = dashboardContext?.getCatalog('HLPDC').filter(m => currentPath.includes(m.label)) || []
        if (matches.length > 1 || location.pathname === URLAPP.root) {
            setHelpDocument(String(matches.reduce((a, b) => a.label.length > b.label.length ? a : b, { value: '', label: '', active: true })?.value))
        } else {
            setHelpDocument('')
        }
    }, [location.pathname])

    return (<DocumentationProvider>
        <section className={`section`}>
            {children}
            {helpDocument && <>
                <Fab
                    sx={{ position: 'absolute', bottom: 16, right: 18, fontSize: '1.75rem' }}
                    size='medium'
                    className='app-btn-color help-display'
                    onClick={() => navigate(`${location.pathname}?${URLQUERY.help}=1`)}
                >
                    <FontAwesomeIcon icon="question-circle" />
                </Fab>
            </>}
        </section>
        <DocDisplayFullScreen helpDocument={helpDocument} />
    </DocumentationProvider>
    )
}
